import { gql } from "apollo-boost";

export const GET_APP_GAMES = gql`
    query GetAppGames($first: Int, $page: Int) {
        games(
            first: $first
            page: $page
            where: { column: ACTIVE, operator: EQ, value: true }
            orderBy: [{ column: ROW_ORDER, order: ASC }, { column: ID, order: ASC }]
        ) {
            paginatorInfo {
                currentPage
                lastPage
                total
                hasMorePages
            }
            data {
                id
                title
                link_site
                active
                row_order
            }
        }
    }
`;
